import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import iconSpriteSheet from '@govhhs/govhhs-design-system-core/dist/icons/icon-sprite-sheet.svg';
import pictogramSpriteSheet from '@govhhs/govhhs-design-system-core/dist/pictograms/pictogram-sprite-sheet.svg';
import classNames from 'classnames';
export { default as uniqueIdForComponent } from './uniqueIdForComponent';
export function getOtherProps(propTypes, props) {
  var otherProps = Object.assign({}, props);
  Object.keys(propTypes).forEach(function (key) {
    delete otherProps[key];
  });
  return otherProps;
}
export var GRID_WIDTHS = ['1/1', '1/2', '1/3', '2/3', '1/4', '3/4', '1/6', '5/6', '1/12', '5/12', '7/12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '12'];
export var GRID_OFFSETS = ['1/12', '1/6', '1/4', '1/3', '1/2', '5/12', '7/12', '2/3', '3/4', '5/6', '11/12'];
export function getAutoGridCSS(autoGridClassname, minWidth, gridGap) {
  var gridGapStyle = gridGap ? "\n    .wds-l-grid--auto.".concat(autoGridClassname, " > .wds-l-grid--auto__margin-fix {\n      margin-left: -").concat(gridGap / 2, "px;\n      margin-right: -").concat(gridGap / 2, "px;\n    }\n\n    .wds-l-grid--auto.").concat(autoGridClassname, " > .wds-l-grid--auto__margin-fix > * {\n      margin-left: ").concat(gridGap / 2, "px;\n      margin-right: ").concat(gridGap / 2, "px;\n      margin-bottom: ").concat(gridGap, "px;\n    }\n\n    @supports (display: grid) {\n      .wds-l-grid--auto.").concat(autoGridClassname, " > .wds-l-grid--auto__margin-fix {\n          ").concat(gridGap ? "grid-gap: ".concat(gridGap, "px;") : '', "\n      }\n    }\n    ") : '';
  var minWidthStyle = minWidth ? "\n    .wds-l-grid--auto.".concat(autoGridClassname, " > .wds-l-grid--auto__margin-fix > * {\n      flex: 1 1 ").concat(minWidth, "px;\n    }\n\n    @supports (display: grid) {\n      .wds-l-grid--auto.").concat(autoGridClassname, "[data-eq-state$='aboveMin'] > div {\n        grid-template-columns: repeat(auto-fit, minmax(").concat(minWidth, "px, 1fr ));\n      }\n    }") : '';
  return "".concat(gridGapStyle, "\n  ").concat(minWidthStyle);
}
export var ICON_SIZES = ['medium', 'small', 'xsmall'];
export var PICTOGRAM_SIZES = ['medium', 'small'];
export var INPUT_SIZES = ['x-small', 'small', 'medium', 'large', 'x-large'];
export function sizeForIcon(iconSize) {
  switch (iconSize) {
    case 'medium':
      return 24;

    case 'small':
      return 16;

    case 'xsmall':
      return 10;

    default:
      {
        console.error('Invalid size specified for icon. Expected one of ', ICON_SIZES);
        return undefined;
      }
  }
}
export function sizeForPictogram(pictogramSize) {
  switch (pictogramSize) {
    case 'medium':
      return 60;

    case 'small':
      return 36;

    default:
      {
        console.error('Invalid size specified for pictogram. Expected one of ', PICTOGRAM_SIZES);
        return undefined;
      }
  }
}
export var AVATAR_SIZES = ['large', 'medium', 'small'];
export var sizeForAvatar = function sizeForAvatar(size) {
  switch (size) {
    case 'small':
      return 36;

    case 'medium':
      return 60;

    case 'large':
      return 120;

    default:
      {
        console.error('Invalid size specified for avatar. Expected one of ', AVATAR_SIZES);
        return undefined;
      }
  }
};
export function widthClass(width) {
  if (!width) {
    return undefined;
  }

  var widthArrayIndex = 0;
  var foundWidth = false;

  while (widthArrayIndex < GRID_WIDTHS.length && !foundWidth) {
    if (GRID_WIDTHS[widthArrayIndex] === width) {
      foundWidth = true;
    }

    widthArrayIndex += 1;
  }

  if (!foundWidth) {
    console.error('Invalid width specified in grid:', width, '- valid values must be one of ', GRID_WIDTHS);
  }

  return classNames({
    'wds-l-width-one-whole': width === '1/1' || width === '12',
    'wds-l-width-one-half': width === '1/2' || width === '6',
    'wds-l-width-one-third': width === '1/3' || width === '4',
    'wds-l-width-two-thirds': width === '2/3' || width === '8',
    'wds-l-width-one-fourth': width === '1/4' || width === '3',
    'wds-l-width-three-fourths': width === '3/4' || width === '9',
    'wds-l-width-one-sixth': width === '1/6' || width === '2',
    'wds-l-width-five-sixths': width === '5/6' || width === '10',
    'wds-l-width-one-twelfth': width === '1/12' || width === '1',
    'wds-l-width-five-twelfths': width === '5/12' || width === '5',
    'wds-l-width-seven-twelfths': width === '7/12' || width === '7'
  });
}
export function offsetClass(offset) {
  if (!offset) {
    return undefined;
  }

  var offsetArrayIndex = 0;
  var foundOffset = false;

  while (offsetArrayIndex < GRID_OFFSETS.length && !foundOffset) {
    if (GRID_OFFSETS[offsetArrayIndex] === offset) {
      foundOffset = true;
    }

    offsetArrayIndex += 1;
  }

  if (!foundOffset) {
    console.error('Invalid offset specified in grid: ', offset, '- valid values must be one of ', GRID_OFFSETS);
  }

  return classNames({
    'wds-l-offset-one-twelfth': offset === '1/12',
    'wds-l-offset-one-sixth': offset === '1/6',
    'wds-l-offset-one-fourth': offset === '1/4',
    'wds-l-offset-one-third': offset === '1/3',
    'wds-l-offset-five-twelfths': offset === '5/12',
    'wds-l-offset-one-half': offset === '1/2',
    'wds-l-offset-seven-twelfths': offset === '7/12',
    'wds-l-offset-two-thirds': offset === '2/3',
    'wds-l-offset-three-fourths': offset === '3/4',
    'wds-l-offset-five-sixths': offset === '5/6',
    'wds-l-offset-eleven-twelfths': offset === '11/12'
  });
}
export var setFocusWith0Delay = function setFocusWith0Delay(element) {
  element.focus(); // instant focus and lazy focus required for IE11

  setTimeout(function (_element) {
    _element.focus();
  }, 0, element);
};
export var flatten = function flatten(list) {
  return list.reduce(function (a, b) {
    return a.concat(Array.isArray(b) ? flatten(b) : b);
  }, []);
};
export var ConditionalContainer = function ConditionalContainer(_ref) {
  var condition = _ref.condition,
      container = _ref.container,
      children = _ref.children;
  return condition ? container(children) : children;
};
export { iconSpriteSheet, pictogramSpriteSheet };